import { formatPrice } from '@search/helpers/src/formatPrice';
import { Currency } from '@search/filter-enums/enums/Currency';

export const MINIMAL_MORTGAGE_PAYMENT = 15000;
export const minMortgagePaymentFormatted = formatPrice({
    value: MINIMAL_MORTGAGE_PAYMENT * 100,
    currency: Currency.RUB,
});
